import meta from "../helper/meta";
import sendBeacon from "../helper/send-beacon";

const useTrace = false;
let isUnloading = false;

window.addEventListener('beforeunload', () => {
    isUnloading = true;
});

function debug(...params) {
    // IE workaround. See: https://stackoverflow.com/questions/7742781/why-does-javascript-only-work-after-opening-developer-tools-in-ie-once
    try {
        const consoleDebug = (useTrace && console.trace) || console.info || console.log;
        if (consoleDebug.apply) { // TODO: IE9 workaround
            consoleDebug(...params);
        }
    } catch (e) {
    }
}

function info(message, info) {
    if (!isUnloading) {
        const data = {
            message: message,
            info: info
        };

        const url = meta.value("bonprix:infoLogUrl");
        sendBeacon(url, data);
    }
}

function error(message, error, traceId) {
    if (!isUnloading) {
      const data = {
        message: message,
        stacktrace: error?.stack,
        filename: error?.fileName,
        linenumber: error?.lineNumber,
        columnnumber: error?.columnNumber,
        cause: error?.cause,
        traceId: traceId || null,
        url: location.href,
        referrer: document.referrer
      };

      const url = meta.value("bonprix:errorLogUrl");
      sendBeacon(url, data);
      console.error(message, error);
    }
}

export default {
    debug,
    info,
    error
};
